import React from "react";
import Switch from "react-switch";
import Navbar from "../../../@shared/navigations/default";
import {AiOutlineTags, AiOutlineUserAdd, AiOutlineComment, AiOutlineMail, AiOutlineShopping, AiOutlineUsergroupAdd, AiOutlineFileDone} from 'react-icons/ai'
import { Options } from "../options";

const AccountNotificationPage = () => {
    return (
      <>
      <Navbar />
        <div className="container3">
           <div className="">
        
              <div>
                 <NotificationSettings />
              </div>

              <div>
              <Options title="Favorites" path='/account/notification' /> <br />
              </div>
           
           </div>
        </div>

      </>
    )
  }
 
export default AccountNotificationPage
  
export const notifyList =[
    {title:'Mentions', check:true, symbol: <AiOutlineTags />, description:'You will receive an alert when someone was mentioned you in any post.'},
    {title:'Follows', symbol: <AiOutlineUserAdd />, description:'You will receive an alert when someone is follwing you.'},
    {title:'Comments', check:true, symbol: <AiOutlineComment />, description:'You will receive an notifications when someone is comment on your post.'},
    {title:'Email Notifications', symbol: <AiOutlineMail />, description:'You will receive daily email notifications.'},
    {title:'New Product', symbol: <AiOutlineShopping />, description:'You will receive an notifications when a new product arrived.'},
    {title:'Groups Invitation', symbol: <AiOutlineUsergroupAdd />, description:'You will receive an notifications when a group is inviting you.'},
    {title:'Tasks', check:true, symbol: <AiOutlineFileDone />, description:'You will receive an notifications someone assign you a task'},
]

export const NotificationSettings = () => {
    return (
        <ul className="notify_settings">
         {
             notifyList.map((item,i)=>(
               <NotificationItem item={item}  key={'notification-setting'+i} />
             ))
         }
        </ul>
    )
}

export const NotificationItem = ({item}) => {
    const [check, setCheck] = React.useState(item.check || false)

    return (
        <li>
            <div>
                {item.symbol}
            </div>
            <div>
                <h5 className="name">{item.title}</h5>
                <p>{item.description}</p>
            </div>
            <div>
                <Switcher check={check} setCheck={setCheck}/>
            </div>
        </li>
    )
}


export const Switcher = ({check, w,h,d}) => {
    const [checked, setChecked] = React.useState(check || false )

    const handleChange = () => {
        setChecked(!checked)
    }

    // React.useEffect(()=>{ setChecked(!checked) },[check])


    return <div
            className={checked?`originalColor`:``}
        >
        <Switch
        onChange={handleChange}
        checked={checked}
        uncheckedIcon={false}
        checkedIcon={false}
        onColor="#3e82f7"
        offColor="#bfbfbf"
        width={w||50}
        height={h||25}
        handleDiameter={d||20}
    /></div>
   
}